import { useState } from 'react';
import Modal from '@mui/material/Modal';
import styled from 'styled-components';
import { Dialog } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { NotificationStep } from './NotificationStep.jsx';
import { useMessageForm } from '../Posts/hooks/useMessageForm';
import { NotificationsModal } from './NotificationsModal.jsx';
import {
  CHOOSE,
  MESSAGE,
  REMINDER,
  REVIEW,
  REVIEW_WITHOUT_NOTIFICATION,
} from '../../utils/constants';
import { ReminderStep } from './ReminderStep.jsx';
import { ReviewStep } from './ReviewStep.jsx';
import ModalConfirmation from '../../../../shared/ModalConfirmation/ModalConfirmation.jsx';
import { ChooseStep } from './ChooseStep.jsx';
import { ReviewWithoutNotificationsStep } from './ReviewWithoutNotificationsStep.jsx';

const getModalTitle = step => {
  switch (step) {
    case CHOOSE:
      return 'chooseTitle';
    case REVIEW_WITHOUT_NOTIFICATION:
      return 'makeLiveNowTitle';
    default:
      return 'title';
  }
};

const MessageReviewModal = ({
  messageModal,
  closeModal,
  messageId,
  campaignId,
  endDate,
  post,
}) => {
  const { open: modalOpen } = messageModal;
  const [step, setStep] = useState({
    currentStep: messageModal.page,
    previousStep: null,
    singleStep: messageModal.singleStep,
  });
  const [openPostNow, setOpenPostNow] = useState(false);
  const { t } = useTranslation('postNotifications');

  const { publishDate, uuid: postId } = post;

  const messageForm = useMessageForm({
    messageId,
    campaignId,
    closeModal,
    isModalOpen: modalOpen,
    tab: step.currentStep,
    publishDate,
    postId,
    endDate,
    ...post,
  });

  return (
    <MessageModal open={modalOpen} onClose={closeModal}>
      <NotificationsModal
        onClose={closeModal}
        messageForm={messageForm}
        setStep={setStep}
        step={step}
        setOpenPostNow={setOpenPostNow}
        post={post}
        title={t(`header.${getModalTitle(step.currentStep)}`)}
      >
        {step.currentStep === CHOOSE && <ChooseStep setStep={setStep} />}
        {step.currentStep === MESSAGE && (
          <NotificationStep messageForm={messageForm} tab={step.currentStep} />
        )}
        {step.currentStep === REMINDER && (
          <ReminderStep
            messageForm={messageForm}
            tab={step.currentStep}
            post={post}
          />
        )}
        {step.currentStep === REVIEW && (
          <>
            <ReviewStep
              post={post}
              messageForm={messageForm}
              previousStep={step.previousStep}
            />
            <Dialog open={openPostNow} onClose={() => setOpenPostNow(false)}>
              <ModalWrapper>
                <ModalConfirmation
                  header={t('postNow.title', { count: post.tiles.length })}
                  body={t('postNow.body')}
                  cancelText={t('postNow.cancel')}
                  submitText={t('postNow.submit')}
                  cancelMode="text"
                  onSave={() => {
                    messageForm.publishPostNow();
                    setOpenPostNow(false);
                    closeModal();
                  }}
                  onCancel={() => {
                    setOpenPostNow(false);
                  }}
                />
              </ModalWrapper>
            </Dialog>
          </>
        )}
        {step.currentStep === REVIEW_WITHOUT_NOTIFICATION && (
          <ReviewWithoutNotificationsStep post={post} />
        )}
      </NotificationsModal>
    </MessageModal>
  );
};

export default MessageReviewModal;

const MessageModal = styled(Modal)`
  overflow: auto;
`;

const ModalWrapper = styled.div`
  padding: 20px;
`;
